import { Map as MapLibreMap, type LngLatBoundsLike } from "maplibre-gl";
import { bbox } from "@turf/turf";
import type { Task } from "@/types/task";

export const zoomToTask = (task: Task, mapInstance: MapLibreMap | null) => {
  if (!mapInstance || !task.geom) return;

  const { geom } = task;

  try {
    switch (geom.type) {
      case "Point": {
        const coordinates = geom.coordinates as [number, number];
        mapInstance.flyTo({
          center: coordinates,
          zoom: 15,
          essential: true,
        });
        return;
      }

      case "LineString":
      case "Polygon":
      case "MultiPoint":
      case "MultiLineString":
      case "MultiPolygon": {
        const geojson: GeoJSON.Feature = {
          type: "Feature",
          geometry: geom,
          properties: {},
        };

        const [minLng, minLat, maxLng, maxLat] = bbox(geojson);
        const bounds: LngLatBoundsLike = [
          [minLng, minLat],
          [maxLng, maxLat],
        ];

        mapInstance.fitBounds(bounds, {
          padding: { top: 20, bottom: 60, left: 20, right: 20 },
          essential: true,
        });
        break;
      }

      default:
        return;
    }
  } catch (error) {
    console.error(`Error zooming to task ${task.id}:`, error);
  }
};

export const tasksToGeoJSON = (tasks: Task[]): GeoJSON.FeatureCollection => {
  return {
    type: "FeatureCollection",
    features: tasks
      .filter((task) => task.geom)
      .map((task) => ({
        type: "Feature",
        geometry: task.geom!,
        properties: {
          id: task.id,
          title: task.title,
          description: task.description,
          status: task.status?.label,
          status_color: task.status?.color,
          category: task.category?.label,
          category_color: task.category?.color,
          priority: task.priority?.label,
          priority_color: task.priority?.color,
          due_date: task.due_date,
          assignee_type: task.assignee_type,
          created_at: task.created_at,
          updated_at: task.updated_at,
        },
      })),
  };
};
